import { useEffect, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQualityCheck,
  addQualityCheck,
  updateQualityCheck,
} from "../../../redux/actions/qualityCheckActions";
import { fetchProducts } from "../../../redux/actions/productActions";
import { Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { NavContext } from "../../NavContext";
import Select from "react-select";

const QualityCheckForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const { activeNav, setActiveNav } = useContext(NavContext);
  useEffect(() => {
    setActiveNav("qualityChecks");
  }, [setActiveNav]);
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const products = useSelector((state) => state.productReducer.products);
  const isFetching = useSelector((state) => state.productReducer.isFetching);

  const qualityCheck = useSelector((state) => state.qualityCheckReducer.qualityCheck);

  useEffect(() => {
    if (id) {
      dispatch(fetchQualityCheck(id));
    } else {
      setSelectedProducts([]);
      reset({ question: "" });
    }
  }, [dispatch, setSelectedProducts, reset, id]);

  useEffect(() => {
    if (!isFetching) {
      dispatch(fetchProducts());
    }
    if (id && qualityCheck) {
      setSelectedProducts(qualityCheck.products);
      reset({
        name: qualityCheck.name,
        description: qualityCheck.description,
        products: qualityCheck.products,
      });
    }
  }, [dispatch, id, qualityCheck, reset, isFetching, products]);

  const handleProductAddition = (productId) => {
    const productToAdd = products.find((product) => product._id === productId);
    if (productToAdd && !selectedProducts.some((product) => product._id === productId)) {
      setSelectedProducts((prevProducts) => [...prevProducts, productToAdd]);
    }
  };

  const handleProductRemoval = (productId) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.filter((product) => product._id !== productId)
    );
  };
  const productList = products.map((option) => ({
    value: option._id,
    label: option.name,
  }));

  const onSubmit = (data) => {
    if (qualityCheck && id) {
      dispatch(
        updateQualityCheck(qualityCheck._id, { ...data, products: selectedProducts })
      );
    } else {
      dispatch(addQualityCheck({ ...data, products: selectedProducts }));
    }
    navigate("/quality-checks");
    reset();
  };

  return (
    <>
      <div className="pb-4">
        <nav aria-label="breadcrumb" className="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-0 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"></li>
            <li className="breadcrumb-item text-sm text-dark " aria-current="page">
              <Link to={`/quality-checks`}>Critéres de qualités</Link>
            </li>
            <li className="breadcrumb-item text-sm text-dark " aria-current="page">
              {qualityCheck ? "Modification du Critére" : " Nouveau Critéres"}
            </li>
          </ol>
        </nav>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <Row>
            <Col className="d-flex flex-column mx-auto">
              <div className="card medium-card mb-4 pb-2 purple-border">
                <div className="card-header text-left">
                  <Col md={6}>
                    {qualityCheck ? (
                      <h6>
                        <span className="product-title px-3 text-white">
                          Modification de la question : {qualityCheck.question}
                        </span>
                      </h6>
                    ) : (
                      <h6>
                        <span className="product-title px-3 text-white">
                          Nouvelle question
                        </span>
                      </h6>
                    )}
                  </Col>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Nom du critère de qualité :
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      {...register("name", { required: true })}
                    />
                    {errors.name && (
                      <div className="text-danger">Nom du critère de qualité requis</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description :
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="3"
                      {...register("description", { required: true })}
                    ></textarea>
                    {errors.description && (
                      <div className="text-danger">Description requise</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="productSelect" className="form-label">
                      Ajouter un produit :
                    </label>
                    <Select
                      options={productList}
                      isClearable={true}
                      placeholder="Sélectionnez un produit"
                      onChange={(e) => handleProductAddition(e.value)}
                    />

                    <ul className="mt-3">
                      {selectedProducts.map((product) => (
                        <li key={product._id} className="d-flex align-items-center">
                          {product.name}
                          <span
                            className="ml-2 cursor-pointer"
                            onClick={() => handleProductRemoval(product._id)}
                          >
                            ✖️
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="">
                    <button type="submit" className="btn bg-gradient-dark w-30 mt-4 mb-0">
                      Enregistrer
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Link to={`/quality-checks`} className="link-action back">
                Retour
              </Link>
            </Col>
          </Row>
        </section>
      </form>
    </>
  );
};

export default QualityCheckForm;
